import { useNavigate } from "react-router-dom";
import { useSelector } from "react-redux";
import { Button } from "react-bootstrap";
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faRotateLeft } from '@fortawesome/free-solid-svg-icons';
import ToggleSwitch from "../ToggleSwitch";

const StartQuiz = ({ gradeQuiz, setGradeQuiz, setQuizStarted, setShowStart, challenged, setQuiz, liveQuiz }) => {
    const { quizUserInfo } = useSelector(state => state.quizAuth);
    const navigate = useNavigate();

    function startQuiz(e) {
        e.preventDefault();
        setQuizStarted(true);
        setShowStart(false);
    }

    function goBack(e) {
        e.preventDefault();
        setQuiz(null);
        setShowStart(false);
        setGradeQuiz(false);
        if (challenged) {
            navigate('/quizgame/quizprofile');
        }
    }

    return (
        <div className="modal-overlay">
            <div className="modal-box">
                <h4>Quiz is ready</h4>
                <div className="grade-me-toggle">
                    <h4 className="mx-10 fs-4">Grade Me</h4>
                    {liveQuiz &&
                    <p>
                        This is a live quiz, but you still have the option of storing your results for your own score keeping or just taking it for fun. 
                    </p>}
                    <ToggleSwitch
                        disabled={!quizUserInfo}
                        checked={gradeQuiz}
                        onChangeFunction={setGradeQuiz}
                    />
                    {quizUserInfo ? (
                        <p className="grading-style">
                            {gradeQuiz ? "Quiz will be graded and results stored, once you start you can't change your mind." : "No thanks, I'm just here for fun"}
                        </p>
                    ) : (
                        <p className="grading-style">
                            To grade your quiz and save results, register or login.
                        </p>
                    )}
                    
                </div>

                {quizUserInfo && <p>*Once you start the quiz, you will not be able to retake it. No practice before grading.</p>}
                <div className="group-btns-quiz">
                    <Button className="quiz-btn-dark" onClick={(e) => startQuiz(e)}>
                        Start Quiz
                    </Button>
                    {!liveQuiz && 
                    <Button className="quiz-btn-dark" onClick={(e) => goBack(e)}>
                        <FontAwesomeIcon icon={faRotateLeft} className="me-2"/> 
                        Go Back
                    </Button>}
                </div>
            </div>
        </div>
    );
}

export default StartQuiz